// redux/features/report/reportSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import reportService from "../../../services/reportService";

const initialState = {
  reportData:   null,
  activePeriod: null, // "daily" | "weekly" | "monthly" | "yearly" | "custom"
  isLoading:    false,
  error:        null,
};

export const getCustomReport  = createAsyncThunk("report/custom",  async (data, t) => { try { return await reportService.getCustomReport(data);  } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getDailyReport   = createAsyncThunk("report/daily",   async (_, t)    => { try { return await reportService.getDailyReport();         } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getWeeklyReport  = createAsyncThunk("report/weekly",  async (_, t)    => { try { return await reportService.getWeeklyReport();        } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getMonthlyReport = createAsyncThunk("report/monthly", async (_, t)    => { try { return await reportService.getMonthlyReport();       } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getYearlyReport  = createAsyncThunk("report/yearly",  async (_, t)    => { try { return await reportService.getYearlyReport();        } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    clearReport: (state) => { state.reportData = null; state.activePeriod = null; },
  },
  extraReducers: (builder) => {
    const handle = (thunk, period) => {
      builder
        .addCase(thunk.pending,   (state) => { state.isLoading = true; state.error = null; })
        .addCase(thunk.fulfilled, (state, action) => {
          state.isLoading   = false;
          state.reportData  = action.payload;
          state.activePeriod = period;
        })
        .addCase(thunk.rejected,  (state, action) => {
          state.isLoading = false;
          state.error     = action.payload;
          toast.error(action.payload);
        });
    };
    handle(getCustomReport,  "custom");
    handle(getDailyReport,   "daily");
    handle(getWeeklyReport,  "weekly");
    handle(getMonthlyReport, "monthly");
    handle(getYearlyReport,  "yearly");
  },
});

export const { clearReport } = reportSlice.actions;
export default reportSlice.reducer;